import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsCardComponent } from "./ds-card.component";
import { DsLoaderModule } from "../ds-loader/ds-loader.module";

@NgModule({
  declarations: [DsCardComponent],
  imports: [CommonModule, DsLoaderModule],
  exports: [DsCardComponent, DsLoaderModule],
})
export class DsCardModule {}
